import { Component } from '@angular/core';
import {Router} from "@angular/router";
import {AuthService} from "../../services/auth.service";
import Swal from "sweetalert2";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {FormValidationService} from "../../services/form-validation.service";

@Component({
  selector: 'app-footer-newsletter',
  templateUrl: './footer-newsletter.component.html',
  styleUrls: ['./footer-newsletter.component.scss']
})
export class FooterNewsletterComponent {
  newsletterform!: FormGroup;
  strict: boolean = false;

  constructor(readonly router: Router, readonly formValidationService: FormValidationService,
              private authService: AuthService, private _formBuilder: FormBuilder) {

    this.newsletterform = this._formBuilder.group({
      terms: ['', [Validators.requiredTrue]],
      email: ['', [Validators.required, Validators.email]]
    });
  }

  singinNewsletter(){
    if (this.formValidationService.getValidationErrors(this.newsletterform).length !== 0) {
      this.strict = true;
    } else {
      this.authService.singinNewsletter(this.newsletterform.get('email')?.value)
        .subscribe({
          next: data => {
            if (data.result) {
              this.newsletterform.patchValue({email: '', terms: ''});
              this.newsletterform.markAsUntouched();
              this.strict = false;
              Swal.fire({
                text: data.message,
                icon: 'success',
                iconColor: '#008835',
                showCloseButton: true,
                showConfirmButton: false,
              });
            } else {
              Swal.fire({
                text: data.message,
                icon: 'error',
                iconColor: '#008835',
                showCloseButton: true,
                showConfirmButton: false,
              });
            }
          }
        });
    }
  }

  markAsTouched() {
    this.newsletterform.get('terms')?.markAsTouched();
  }
}
